import { Box } from '@rbilabs/universal-components';

export const StoreCardListContainer = Box.withConfig({
  width: 'full',
});
